/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedRefineMenuDisplayPrefsSelect_user$ref = any;
export type SbSharedRefineMenuDisplayPrefsSelect_user = {
    readonly isVerifiedTrade: boolean | null;
    readonly " $refType": SbSharedRefineMenuDisplayPrefsSelect_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedRefineMenuDisplayPrefsSelect_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "isVerifiedTrade",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = 'dbe4e541582a5514bad9681d998d2c33';
export default node;
